/** Shared display format. Keep timestamps, date inputs and API serialization unchanged. */
export function formatDisplayDate(value: Date | string | number, options: Intl.DateTimeFormatOptions = {
  year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
}): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const parts = new Intl.DateTimeFormat("zh-CN", { ...options, ...(options.dateStyle === "short" ? { dateStyle: "medium" } : {}), ...(options.year === "2-digit" ? { year: "numeric" } : {}) }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find(item => item.type === type)?.value;
  const calendar = (["year", "month", "day"] as const).map(type => {
    const text = part(type);
    return text ? text.replace(/月$/u, "").padStart(type === "year" ? 4 : 2, "0") : null;
  }).filter(Boolean).join("-");
  const time = (["hour", "minute", "second"] as const).map(type => part(type)?.padStart(2, "0")).filter(Boolean).join(":");
  return [calendar, part("dayPeriod"), time, part("weekday")].filter(Boolean).join(" ");
}
